import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsDesktop = (
  slug,
  dispatch,
  translate,
  updateServiceGroupStatus,
  handleSortChange,
  setServiceGroupId,
  setShowDeleteConfirmation,
  setServiceGroupName,
  setSelectedServiceCount,
  openEditSidePanelModal,
  hasAccessToEdit
) => {
  return [
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("serviceGroup.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      width: 400,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        return (
          <HStack gap={2}>
            <Stack gap={0}>
              <Text
                fontSize="15px"
                color={textPrimary}
                fontWeight="600"
                textAlign="left"
                isTruncated // This will add ellipsis
                maxW="360px"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("services")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("serviceGroup.columnServiceCount")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "services",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { serviceCount } = row.original;

        if (!serviceCount) {
          return (
            <Text
              textAlign="left"
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
            >
              0
            </Text>
          );
        }

        return (
          <Text
            textAlign="left"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="sm"
            color={textSecondary}
            fontWeight="500"
          >
            {serviceCount}
          </Text>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id, serviceCount } = row.original;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateServiceGroupStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              // p="0 2.5rem"
              minW="160px"
              isUnclickable={!hasAccessToEdit}
            />

            <MoreButtonLite
              id={_id}
              deleteHandler={true}
              viewHandler={() => {
                setServiceGroupId(_id); // Set the user ID for viewing
                openEditSidePanelModal(); // Open the side panel for viewing
              }}
              setShowDeleteConfirmation={() => {
                setServiceGroupId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setSelectedServiceCount(serviceCount);
                setServiceGroupName(row.original.name);
              }}
            />
          </HStack>
        );
      },
    },
  ];
};
